import type { Wallet } from '../types'

/** Complete wallet picker catalog transcribed from the source project's actual modal registry.
 * Icons are local copies in public/wallets; null means the source catalog had no icon file.
 * Custom adapters must be registered by the consuming application.
 */
export const defaultWallets: Wallet[] = [
  {
    "id": "walletconn",
    "name": "WalletConnect",
    "icon": "assets/wallet-modal/wallets/walletconn.webp",
    "description": "Connect using WalletConnect",
    "color": "#8b75ff",
    "mark": "W",
    "aliases": [
      "Wallet Connect",
      "WC"
    ],
    "chains": [],
    "adapterId": "walletconn",
    "provider": "custom-adapter",
    "installUrl": "https://walletconnect.com/"
  },
  {
    "id": "metamask",
    "name": "MetaMask",
    "icon": "assets/wallet-modal/wallets/metamask.webp",
    "description": "Connect using MetaMask",
    "color": "#ee9b48",
    "mark": "M",
    "aliases": [
      "Meta Mask",
      "MM"
    ],
    "chains": [],
    "adapterId": "injected",
    "provider": "eip1193-injected",
    "installUrl": "https://metamask.io/"
  },
  {
    "id": "coinbase",
    "name": "Coinbase Wallet",
    "icon": "assets/wallet-modal/wallets/coinbase.webp",
    "description": "Connect using Coinbase",
    "color": "#35a8df",
    "mark": "C",
    "aliases": [
      "Coinbase Wallet",
      "CB Wallet"
    ],
    "chains": [],
    "adapterId": "injected",
    "provider": "eip1193-injected",
    "installUrl": "https://www.coinbase.com/"
  },
  {
    "id": "trust",
    "name": "Trust Wallet",
    "icon": "assets/wallet-modal/wallets/trust.webp",
    "description": "Connect using Trust Wallet",
    "color": "#24b99a",
    "mark": "TW",
    "aliases": [
      "Trust"
    ],
    "chains": [],
    "adapterId": "trust",
    "provider": "custom-adapter",
    "installUrl": "https://trustwallet.com/"
  },
  {
    "id": "okx",
    "name": "OKX Wallet",
    "icon": "assets/wallet-modal/wallets/okx.webp",
    "description": "Connect using OKX Wallet",
    "color": "#e879ae",
    "mark": "OW",
    "aliases": [
      "OKX",
      "OKEx Wallet"
    ],
    "chains": [],
    "adapterId": "okx",
    "provider": "custom-adapter",
    "installUrl": "https://okx.com/"
  },
  {
    "id": "argent",
    "name": "Argent",
    "icon": "assets/wallet-modal/wallets/argent.webp",
    "description": "Connect using Argent",
    "color": "#557eea",
    "mark": "A",
    "aliases": [],
    "chains": [],
    "adapterId": "argent",
    "provider": "custom-adapter",
    "installUrl": "https://www.argent.xyz/"
  },
  {
    "id": "strikex2",
    "name": "Strike X",
    "icon": "assets/wallet-modal/wallets/strikex2.webp",
    "description": "Connect using Strike X",
    "color": "#c5aa54",
    "mark": "SX",
    "aliases": [],
    "chains": [],
    "adapterId": "strikex2",
    "provider": "custom-adapter",
    "installUrl": "https://www.strikeX.io/"
  },
  {
    "id": "blockchain",
    "name": "Blockchain Wallet",
    "icon": "assets/wallet-modal/wallets/blockchain.webp",
    "description": "Connect using Blockchain Wallet",
    "color": "#48b89c",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "blockchain",
    "provider": "custom-adapter",
    "installUrl": "https://blockchain.com/"
  },
  {
    "id": "safe",
    "name": "Safe",
    "icon": "assets/wallet-modal/wallets/safe.webp",
    "description": "Connect using Safe",
    "color": "#8063d9",
    "mark": "S",
    "aliases": [],
    "chains": [],
    "adapterId": "safe",
    "provider": "custom-adapter",
    "installUrl": "https://www.safe.com/"
  },
  {
    "id": "rainbow",
    "name": "Rainbow Wallet",
    "icon": "assets/wallet-modal/wallets/rainbow.webp",
    "description": "Connect using Rainbow Wallet",
    "color": "#de7a50",
    "mark": "RW",
    "aliases": [
      "Rainbow"
    ],
    "chains": [],
    "adapterId": "rainbow",
    "provider": "custom-adapter",
    "installUrl": "https://www.rainbow.me/"
  },
  {
    "id": "uniswap",
    "name": "Uniswap Wallet",
    "icon": "assets/wallet-modal/wallets/uniswap.webp",
    "description": "Connect using Uniswap Wallet",
    "color": "#8b75ff",
    "mark": "UW",
    "aliases": [
      "Uniswap"
    ],
    "chains": [],
    "adapterId": "uniswap",
    "provider": "custom-adapter",
    "installUrl": "https://uniswap.org/"
  },
  {
    "id": "zerion",
    "name": "Zerion",
    "icon": "assets/wallet-modal/wallets/zerion.webp",
    "description": "Connect using Zerion",
    "color": "#ee9b48",
    "mark": "Z",
    "aliases": [],
    "chains": [],
    "adapterId": "zerion",
    "provider": "custom-adapter",
    "installUrl": "https://www.zerion.io/"
  },
  {
    "id": "bitget",
    "name": "Bitget Wallet",
    "icon": "assets/wallet-modal/wallets/bitget.webp",
    "description": "Connect using Bitget Wallet",
    "color": "#35a8df",
    "mark": "BW",
    "aliases": [
      "BitKeep"
    ],
    "chains": [],
    "adapterId": "bitget",
    "provider": "custom-adapter",
    "installUrl": "https://www.bitget.com/en/"
  },
  {
    "id": "bitski",
    "name": "Bitski",
    "icon": "assets/wallet-modal/wallets/bitski.webp",
    "description": "Connect using Bitski",
    "color": "#24b99a",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "bitski",
    "provider": "custom-adapter",
    "installUrl": "https://bitski.xyz/"
  },
  {
    "id": "imtoken",
    "name": "imToken",
    "icon": "assets/wallet-modal/wallets/imtoken.webp",
    "description": "Connect using imToken",
    "color": "#e879ae",
    "mark": "I",
    "aliases": [
      "imToken Wallet"
    ],
    "chains": [],
    "adapterId": "imtoken",
    "provider": "custom-adapter",
    "installUrl": "https://imtoken.io/"
  },
  {
    "id": "bybit",
    "name": "ByBit Wallet",
    "icon": "assets/wallet-modal/wallets/bybit.webp",
    "description": "Connect using ByBit Wallet",
    "color": "#557eea",
    "mark": "BW",
    "aliases": [
      "Bybit"
    ],
    "chains": [],
    "adapterId": "bybit",
    "provider": "custom-adapter",
    "installUrl": "https://www.bybit.com/"
  },
  {
    "id": "crypto",
    "name": "Crypto.com",
    "icon": "assets/wallet-modal/wallets/crypto.webp",
    "description": "Connect using Crypto.com",
    "color": "#c5aa54",
    "mark": "CC",
    "aliases": [
      "Crypto.com Onchain"
    ],
    "chains": [],
    "adapterId": "crypto",
    "provider": "custom-adapter",
    "installUrl": "https://www.crypto.com/"
  },
  {
    "id": "bitfrost",
    "name": "BitFrost",
    "icon": "assets/wallet-modal/wallets/bitfrost.svg",
    "description": "Connect using BitFrost",
    "color": "#48b89c",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "bitfrost",
    "provider": "custom-adapter",
    "installUrl": "https://www.bitfrost.com/"
  },
  {
    "id": "tokenpocket",
    "name": "TokenPocket",
    "icon": "assets/wallet-modal/wallets/tokenpocket.webp",
    "description": "Connect using TokenPocket",
    "color": "#8063d9",
    "mark": "T",
    "aliases": [
      "Token Pocket"
    ],
    "chains": [],
    "adapterId": "tokenpocket",
    "provider": "custom-adapter",
    "installUrl": "https://www.tokenpocket.pro/"
  },
  {
    "id": "robinhood",
    "name": "Robinhood",
    "icon": "assets/wallet-modal/wallets/Robinhood.webp",
    "description": "Connect using Robinhood",
    "color": "#de7a50",
    "mark": "R",
    "aliases": [
      "Robinhood Wallet"
    ],
    "chains": [],
    "adapterId": "robinhood",
    "provider": "custom-adapter",
    "installUrl": "https://robinhood.com/"
  },
  {
    "id": "frontier",
    "name": "Frontier",
    "icon": "assets/wallet-modal/wallets/frontier.webp",
    "description": "Connect using Frontier",
    "color": "#8b75ff",
    "mark": "F",
    "aliases": [],
    "chains": [],
    "adapterId": "frontier",
    "provider": "custom-adapter",
    "installUrl": "https://www.frontier.xyz/"
  },
  {
    "id": "safepal",
    "name": "SafePal",
    "icon": "assets/wallet-modal/wallets/safepal.webp",
    "description": "Connect using SafePal",
    "color": "#ee9b48",
    "mark": "S",
    "aliases": [
      "Safe Pal"
    ],
    "chains": [],
    "adapterId": "safepal",
    "provider": "custom-adapter",
    "installUrl": "https://safepal.io/"
  },
  {
    "id": "omni",
    "name": "Omni",
    "icon": "assets/wallet-modal/wallets/omni.webp",
    "description": "Connect using Omni",
    "color": "#35a8df",
    "mark": "O",
    "aliases": [],
    "chains": [],
    "adapterId": "omni",
    "provider": "custom-adapter",
    "installUrl": "https://omniwallet.io/"
  },
  {
    "id": "zengo",
    "name": "Zengo Wallet",
    "icon": "assets/wallet-modal/wallets/zengo.webp",
    "description": "Connect using Zengo Wallet",
    "color": "#24b99a",
    "mark": "ZW",
    "aliases": [
      "Zengo"
    ],
    "chains": [],
    "adapterId": "zengo",
    "provider": "custom-adapter",
    "installUrl": "https://zengo.io/"
  },
  {
    "id": "bitverse",
    "name": "Bitverse",
    "icon": "assets/wallet-modal/wallets/bitverse.webp",
    "description": "Connect using Bitverse",
    "color": "#e879ae",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "bitverse",
    "provider": "custom-adapter",
    "installUrl": "https://www.bitverse.io/"
  },
  {
    "id": "1inch",
    "name": "1inch Wallet",
    "icon": "assets/wallet-modal/wallets/1inch.webp",
    "description": "Connect using 1inch Wallet",
    "color": "#557eea",
    "mark": "1W",
    "aliases": [
      "1inch"
    ],
    "chains": [],
    "adapterId": "1inch",
    "provider": "custom-adapter",
    "installUrl": "https://1inch.io/"
  },
  {
    "id": "alpha",
    "name": "Alpha Wallet",
    "icon": "assets/wallet-modal/wallets/alpha.webp",
    "description": "Connect using Alpha Wallet",
    "color": "#c5aa54",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "alpha",
    "provider": "custom-adapter",
    "installUrl": "https://alphawallet.com/"
  },
  {
    "id": "keyring",
    "name": "KEYRING Wallet",
    "icon": "assets/wallet-modal/wallets/keyring.webp",
    "description": "Connect using KEYRING Wallet",
    "color": "#48b89c",
    "mark": "KW",
    "aliases": [
      "Keyring"
    ],
    "chains": [],
    "adapterId": "keyring",
    "provider": "custom-adapter",
    "installUrl": "https://keyring.io/"
  },
  {
    "id": "binance",
    "name": "Binance Wallet",
    "icon": "assets/wallet-modal/wallets/binance.webp",
    "description": "Connect using Binance Wallet",
    "color": "#8063d9",
    "mark": "BW",
    "aliases": [
      "Binance Web3 Wallet"
    ],
    "chains": [],
    "adapterId": "binance",
    "provider": "custom-adapter",
    "installUrl": "https://www.binance.com/en"
  },
  {
    "id": "mew",
    "name": "MEW Wallet",
    "icon": "assets/wallet-modal/wallets/mew.webp",
    "description": "Connect using MEW Wallet",
    "color": "#de7a50",
    "mark": "MW",
    "aliases": [
      "MyEtherWallet",
      "MEW"
    ],
    "chains": [],
    "adapterId": "mew",
    "provider": "custom-adapter",
    "installUrl": "https://mewwallet.com/"
  },
  {
    "id": "exodus",
    "name": "Exodus",
    "icon": "assets/wallet-modal/wallets/exodus.webp",
    "description": "Connect using Exodus",
    "color": "#8b75ff",
    "mark": "E",
    "aliases": [
      "Exodus Wallet"
    ],
    "chains": [],
    "adapterId": "exodus",
    "provider": "custom-adapter",
    "installUrl": "https://www.exodus.io/"
  },
  {
    "id": "ledger",
    "name": "Ledger Live",
    "icon": "assets/wallet-modal/wallets/ledger.webp",
    "description": "Connect using Ledger Live",
    "color": "#ee9b48",
    "mark": "LL",
    "aliases": [
      "Ledger"
    ],
    "chains": [],
    "adapterId": "ledger",
    "provider": "custom-adapter",
    "installUrl": "https://www.ledger.com/"
  },
  {
    "id": "bitpie",
    "name": "Bitpie",
    "icon": "assets/wallet-modal/wallets/bitpie.webp",
    "description": "Connect using Bitpie",
    "color": "#35a8df",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "bitpie",
    "provider": "custom-adapter",
    "installUrl": "https://bitpie.com/"
  },
  {
    "id": "lobstr",
    "name": "LOBSTR Wallet",
    "icon": "assets/wallet-modal/wallets/lobstr.webp",
    "description": "Connect using LOBSTR Wallet",
    "color": "#24b99a",
    "mark": "LW",
    "aliases": [],
    "chains": [
      "Stellar"
    ],
    "adapterId": "lobstr",
    "provider": "custom-adapter",
    "installUrl": "https://lobstr.co/"
  },
  {
    "id": "math",
    "name": "MathWallet",
    "icon": "assets/wallet-modal/wallets/math.webp",
    "description": "Connect using MathWallet",
    "color": "#e879ae",
    "mark": "M",
    "aliases": [
      "Math Wallet"
    ],
    "chains": [],
    "adapterId": "math",
    "provider": "custom-adapter",
    "installUrl": "https://mathwallet.com/"
  },
  {
    "id": "unstoppable",
    "name": "Unstoppable Wallet",
    "icon": "assets/wallet-modal/wallets/unstoppable.webp",
    "description": "Connect using Unstoppable Wallet",
    "color": "#557eea",
    "mark": "UW",
    "aliases": [],
    "chains": [],
    "adapterId": "unstoppable",
    "provider": "custom-adapter",
    "installUrl": "https://unstoppabledomains.com/"
  },
  {
    "id": "obvious",
    "name": "Obvious",
    "icon": "assets/wallet-modal/wallets/obvious.webp",
    "description": "Connect using Obvious",
    "color": "#c5aa54",
    "mark": "O",
    "aliases": [],
    "chains": [],
    "adapterId": "obvious",
    "provider": "custom-adapter",
    "installUrl": "https://www.obvious.im/"
  },
  {
    "id": "fireblocks",
    "name": "Fireblocks",
    "icon": "assets/wallet-modal/wallets/fireblocks.webp",
    "description": "Connect using Fireblocks",
    "color": "#48b89c",
    "mark": "F",
    "aliases": [],
    "chains": [],
    "adapterId": "fireblocks",
    "provider": "custom-adapter",
    "installUrl": "https://www.fireblocks.com/"
  },
  {
    "id": "ambire",
    "name": "Ambire Wallet",
    "icon": "assets/wallet-modal/wallets/ambire.webp",
    "description": "Connect using Ambire Wallet",
    "color": "#8063d9",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "ambire",
    "provider": "custom-adapter",
    "installUrl": "https://ambire.io/"
  },
  {
    "id": "infinity",
    "name": "Infinity Wallet",
    "icon": "assets/wallet-modal/wallets/infinity.webp",
    "description": "Connect using Infinity Wallet",
    "color": "#de7a50",
    "mark": "IW",
    "aliases": [],
    "chains": [],
    "adapterId": "infinity",
    "provider": "custom-adapter",
    "installUrl": "https://infinitywallet.io/"
  },
  {
    "id": "bridge",
    "name": "Bridge Wallet",
    "icon": "assets/wallet-modal/wallets/bridge.webp",
    "description": "Connect using Bridge Wallet",
    "color": "#8b75ff",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "bridge",
    "provider": "custom-adapter",
    "installUrl": "https://www.bridge.wallet/"
  },
  {
    "id": "internet",
    "name": "Internet Wallet",
    "icon": "assets/wallet-modal/wallets/internet.webp",
    "description": "Connect using Internet Wallet",
    "color": "#ee9b48",
    "mark": "IW",
    "aliases": [],
    "chains": [],
    "adapterId": "internet",
    "provider": "custom-adapter",
    "installUrl": "https://internetwallet.io/"
  },
  {
    "id": "now",
    "name": "NOW Wallet",
    "icon": "assets/wallet-modal/wallets/now.webp",
    "description": "Connect using NOW Wallet",
    "color": "#35a8df",
    "mark": "NW",
    "aliases": [],
    "chains": [],
    "adapterId": "now",
    "provider": "custom-adapter",
    "installUrl": "https://nowwallet.io/"
  },
  {
    "id": "bitcoin",
    "name": "Bitcoin.com Wallet",
    "icon": "assets/wallet-modal/wallets/bitcoin.webp",
    "description": "Connect using Bitcoin.com Wallet",
    "color": "#24b99a",
    "mark": "BC",
    "aliases": [],
    "chains": [
      "Bitcoin"
    ],
    "adapterId": "bitcoin",
    "provider": "custom-adapter",
    "installUrl": "https://www.bitcoin.com/"
  },
  {
    "id": "abc",
    "name": "ABC Wallet",
    "icon": "assets/wallet-modal/wallets/abc.webp",
    "description": "Connect using ABC Wallet",
    "color": "#e879ae",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "abc",
    "provider": "custom-adapter",
    "installUrl": "https://abcwallet.io/"
  },
  {
    "id": "ottr",
    "name": "Ottr Finance",
    "icon": "assets/wallet-modal/wallets/ottr.webp",
    "description": "Connect using Ottr Finance",
    "color": "#557eea",
    "mark": "OF",
    "aliases": [],
    "chains": [],
    "adapterId": "ottr",
    "provider": "custom-adapter",
    "installUrl": "https://ottr.finance/"
  },
  {
    "id": "alphasymbol",
    "name": "αU Wallet",
    "icon": "assets/wallet-modal/wallets/alphasymbol.webp",
    "description": "Connect using αU Wallet",
    "color": "#c5aa54",
    "mark": "UW",
    "aliases": [],
    "chains": [],
    "adapterId": "alphasymbol",
    "provider": "custom-adapter",
    "installUrl": "https://alphasymbol.com/"
  },
  {
    "id": "fncy",
    "name": "Fncy Mobile Wallet",
    "icon": "assets/wallet-modal/wallets/fncy.webp",
    "description": "Connect using Fncy Mobile Wallet",
    "color": "#48b89c",
    "mark": "FM",
    "aliases": [],
    "chains": [],
    "adapterId": "fncy",
    "provider": "custom-adapter",
    "installUrl": "https://fncy.io/"
  },
  {
    "id": "arculus",
    "name": "Arculus Wallet",
    "icon": "assets/wallet-modal/wallets/arculus.webp",
    "description": "Connect using Arculus Wallet",
    "color": "#8063d9",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "arculus",
    "provider": "custom-adapter",
    "installUrl": "https://arculuswallet.com/"
  },
  {
    "id": "opera",
    "name": "Opera Crypto Wallet",
    "icon": "assets/wallet-modal/wallets/opera.webp",
    "description": "Connect using Opera Crypto Wallet",
    "color": "#de7a50",
    "mark": "OC",
    "aliases": [],
    "chains": [],
    "adapterId": "opera",
    "provider": "custom-adapter",
    "installUrl": "https://opera.com/"
  },
  {
    "id": "cobalt",
    "name": "Cobalt Wallet",
    "icon": "assets/wallet-modal/wallets/cobalt.webp",
    "description": "Connect using Cobalt Wallet",
    "color": "#8b75ff",
    "mark": "CW",
    "aliases": [],
    "chains": [],
    "adapterId": "cobalt",
    "provider": "custom-adapter",
    "installUrl": "https://cobaltwallet.io/"
  },
  {
    "id": "chain",
    "name": "Chain",
    "icon": "assets/wallet-modal/wallets/chain.webp",
    "description": "Connect using Chain",
    "color": "#ee9b48",
    "mark": "C",
    "aliases": [],
    "chains": [],
    "adapterId": "chain",
    "provider": "custom-adapter",
    "installUrl": "https://chainwallet.io/"
  },
  {
    "id": "huddin",
    "name": "Huddin",
    "icon": "assets/wallet-modal/wallets/huddin.webp",
    "description": "Connect using Huddin",
    "color": "#35a8df",
    "mark": "H",
    "aliases": [],
    "chains": [],
    "adapterId": "huddin",
    "provider": "custom-adapter",
    "installUrl": "https://huddin.io/"
  },
  {
    "id": "verso",
    "name": "Verso",
    "icon": "assets/wallet-modal/wallets/verso.webp",
    "description": "Connect using Verso",
    "color": "#24b99a",
    "mark": "V",
    "aliases": [],
    "chains": [],
    "adapterId": "verso",
    "provider": "custom-adapter",
    "installUrl": "https://www.verso.io/"
  },
  {
    "id": "jade",
    "name": "Jade Wallet",
    "icon": "assets/wallet-modal/wallets/jade.webp",
    "description": "Connect using Jade Wallet",
    "color": "#e879ae",
    "mark": "JW",
    "aliases": [],
    "chains": [],
    "adapterId": "jade",
    "provider": "custom-adapter",
    "installUrl": "https://jade-wallet.com/"
  },
  {
    "id": "haha",
    "name": "HaHa",
    "icon": "assets/wallet-modal/wallets/haha.webp",
    "description": "Connect using HaHa",
    "color": "#557eea",
    "mark": "H",
    "aliases": [],
    "chains": [],
    "adapterId": "haha",
    "provider": "custom-adapter",
    "installUrl": "https://www.haha.im/"
  },
  {
    "id": "modular",
    "name": "Modular Wallet",
    "icon": "assets/wallet-modal/wallets/modular.webp",
    "description": "Connect using Modular Wallet",
    "color": "#c5aa54",
    "mark": "MW",
    "aliases": [],
    "chains": [],
    "adapterId": "modular",
    "provider": "custom-adapter",
    "installUrl": "https://modularwallet.io/"
  },
  {
    "id": "kelp",
    "name": "Kelp",
    "icon": "assets/wallet-modal/wallets/kelp.webp",
    "description": "Connect using Kelp",
    "color": "#48b89c",
    "mark": "K",
    "aliases": [],
    "chains": [],
    "adapterId": "kelp",
    "provider": "custom-adapter",
    "installUrl": "https://kelp.io/"
  },
  {
    "id": "numio",
    "name": "Numio",
    "icon": "assets/wallet-modal/wallets/numio.webp",
    "description": "Connect using Numio",
    "color": "#8063d9",
    "mark": "N",
    "aliases": [],
    "chains": [],
    "adapterId": "numio",
    "provider": "custom-adapter",
    "installUrl": "https://num.io/"
  },
  {
    "id": "cling",
    "name": "Cling Wallet",
    "icon": "assets/wallet-modal/wallets/cling.webp",
    "description": "Connect using Cling Wallet",
    "color": "#de7a50",
    "mark": "CW",
    "aliases": [],
    "chains": [],
    "adapterId": "cling",
    "provider": "custom-adapter",
    "installUrl": "https://cling.io/"
  },
  {
    "id": "broeam",
    "name": "Broeam Wallet",
    "icon": "assets/wallet-modal/wallets/broeam.webp",
    "description": "Connect using Broeam Wallet",
    "color": "#8b75ff",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "broeam",
    "provider": "custom-adapter",
    "installUrl": "https://broeam.com/"
  },
  {
    "id": "ripio",
    "name": "Ripio",
    "icon": "assets/wallet-modal/wallets/ripio.webp",
    "description": "Connect using Ripio",
    "color": "#ee9b48",
    "mark": "R",
    "aliases": [],
    "chains": [],
    "adapterId": "ripio",
    "provider": "custom-adapter",
    "installUrl": "https://www.ripio.com/"
  },
  {
    "id": "sabay",
    "name": "Sabay Wallet",
    "icon": null,
    "description": "Connect using Sabay Wallet",
    "color": "#35a8df",
    "mark": "SW",
    "aliases": [],
    "chains": [],
    "adapterId": "sabay",
    "provider": "custom-adapter",
    "installUrl": "https://sabaywallet.com/"
  },
  {
    "id": "tokoin",
    "name": "Tokoin | Wallet",
    "icon": "assets/wallet-modal/wallets/tokoin.webp",
    "description": "Connect using Tokoin | Wallet",
    "color": "#24b99a",
    "mark": "TW",
    "aliases": [],
    "chains": [],
    "adapterId": "tokoin",
    "provider": "custom-adapter",
    "installUrl": "https://tokoin.com/"
  },
  {
    "id": "copiosa",
    "name": "Copiosa",
    "icon": "assets/wallet-modal/wallets/copiosa.webp",
    "description": "Connect using Copiosa",
    "color": "#e879ae",
    "mark": "C",
    "aliases": [],
    "chains": [],
    "adapterId": "copiosa",
    "provider": "custom-adapter",
    "installUrl": "https://copiosa.com/"
  },
  {
    "id": "imota",
    "name": "Imota",
    "icon": "assets/wallet-modal/wallets/imota.webp",
    "description": "Connect using Imota",
    "color": "#557eea",
    "mark": "I",
    "aliases": [],
    "chains": [],
    "adapterId": "imota",
    "provider": "custom-adapter",
    "installUrl": "https://imota.im/"
  },
  {
    "id": "libera",
    "name": "Libera",
    "icon": "assets/wallet-modal/wallets/libera.webp",
    "description": "Connect using Libera",
    "color": "#c5aa54",
    "mark": "L",
    "aliases": [],
    "chains": [],
    "adapterId": "libera",
    "provider": "custom-adapter",
    "installUrl": "https://www.libera.im/"
  },
  {
    "id": "certhis",
    "name": "Certhis",
    "icon": "assets/wallet-modal/wallets/certhis.webp",
    "description": "Connect using Certhis",
    "color": "#48b89c",
    "mark": "C",
    "aliases": [],
    "chains": [],
    "adapterId": "certhis",
    "provider": "custom-adapter",
    "installUrl": "https://certhis.io/"
  },
  {
    "id": "burrito",
    "name": "Burrito",
    "icon": "assets/wallet-modal/wallets/burrito.webp",
    "description": "Connect using Burrito",
    "color": "#8063d9",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "burrito",
    "provider": "custom-adapter",
    "installUrl": "https://burrito.im/"
  },
  {
    "id": "ancrypto",
    "name": "Ancrypto",
    "icon": "assets/wallet-modal/wallets/ancrypto.webp",
    "description": "Connect using Ancrypto",
    "color": "#de7a50",
    "mark": "A",
    "aliases": [],
    "chains": [],
    "adapterId": "ancrypto",
    "provider": "custom-adapter",
    "installUrl": "https://ancrypto.com/"
  },
  {
    "id": "cypherock",
    "name": "Cypherock cySync",
    "icon": "assets/wallet-modal/wallets/cypherock.webp",
    "description": "Connect using Cypherock cySync",
    "color": "#8b75ff",
    "mark": "CC",
    "aliases": [],
    "chains": [],
    "adapterId": "cypherock",
    "provider": "custom-adapter",
    "installUrl": "https://www.cypherock.com/"
  },
  {
    "id": "cvl",
    "name": "CVL Wallet",
    "icon": "assets/wallet-modal/wallets/cvl.webp",
    "description": "Connect using CVL Wallet",
    "color": "#ee9b48",
    "mark": "CW",
    "aliases": [],
    "chains": [],
    "adapterId": "cvl",
    "provider": "custom-adapter",
    "installUrl": "https://cvlwallet.com/"
  },
  {
    "id": "cypher",
    "name": "Cypher Wallet",
    "icon": "assets/wallet-modal/wallets/cypher.webp",
    "description": "Connect using Cypher Wallet",
    "color": "#35a8df",
    "mark": "CW",
    "aliases": [],
    "chains": [],
    "adapterId": "cypher",
    "provider": "custom-adapter",
    "installUrl": "https://www.cypherwallet.io/"
  },
  {
    "id": "status",
    "name": "Status",
    "icon": "assets/wallet-modal/wallets/status.webp",
    "description": "Connect using Status",
    "color": "#24b99a",
    "mark": "S",
    "aliases": [],
    "chains": [],
    "adapterId": "status",
    "provider": "custom-adapter",
    "installUrl": "https://status.im/"
  },
  {
    "id": "enjin",
    "name": "Enjin Wallet",
    "icon": "assets/wallet-modal/wallets/enjin.webp",
    "description": "Connect using Enjin Wallet",
    "color": "#e879ae",
    "mark": "EW",
    "aliases": [],
    "chains": [],
    "adapterId": "enjin",
    "provider": "custom-adapter",
    "installUrl": "https://enjin.io/"
  },
  {
    "id": "essentials",
    "name": "Essentials",
    "icon": "assets/wallet-modal/wallets/essentials.webp",
    "description": "Connect using Essentials",
    "color": "#557eea",
    "mark": "E",
    "aliases": [],
    "chains": [],
    "adapterId": "essentials",
    "provider": "custom-adapter",
    "installUrl": "https://essentials.im/"
  },
  {
    "id": "everspace",
    "name": "Everspace",
    "icon": "assets/wallet-modal/wallets/everspace.webp",
    "description": "Connect using Everspace",
    "color": "#c5aa54",
    "mark": "E",
    "aliases": [],
    "chains": [],
    "adapterId": "everspace",
    "provider": "custom-adapter",
    "installUrl": "https://everspace.im/"
  },
  {
    "id": "blockwallet",
    "name": "BlockWallet",
    "icon": "assets/wallet-modal/wallets/blockwallet.webp",
    "description": "Connect using BlockWallet",
    "color": "#48b89c",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "blockwallet",
    "provider": "custom-adapter",
    "installUrl": "https://blockwallet.io/"
  },
  {
    "id": "kriptomat",
    "name": "Kriptomat",
    "icon": null,
    "description": "Connect using Kriptomat",
    "color": "#8063d9",
    "mark": "K",
    "aliases": [],
    "chains": [],
    "adapterId": "kriptomat",
    "provider": "custom-adapter",
    "installUrl": "https://kriptomat.com/"
  },
  {
    "id": "oxalus",
    "name": "Oxalus Wallet",
    "icon": "assets/wallet-modal/wallets/oxalus.webp",
    "description": "Connect using Oxalus Wallet",
    "color": "#de7a50",
    "mark": "OW",
    "aliases": [],
    "chains": [],
    "adapterId": "oxalus",
    "provider": "custom-adapter",
    "installUrl": "https://www.oxalus.com/"
  },
  {
    "id": "theta",
    "name": "Theta Wallet",
    "icon": "assets/wallet-modal/wallets/theta.webp",
    "description": "Connect using Theta Wallet",
    "color": "#8b75ff",
    "mark": "TW",
    "aliases": [],
    "chains": [],
    "adapterId": "theta",
    "provider": "custom-adapter",
    "installUrl": "https://thetawallet.com/"
  },
  {
    "id": "dawn",
    "name": "Dawn Wallet",
    "icon": "assets/wallet-modal/wallets/dawn.webp",
    "description": "Connect using Dawn Wallet",
    "color": "#ee9b48",
    "mark": "DW",
    "aliases": [],
    "chains": [],
    "adapterId": "dawn",
    "provider": "custom-adapter",
    "installUrl": "https://dawnwallet.com/"
  },
  {
    "id": "rabby",
    "name": "Rabby",
    "icon": "assets/wallet-modal/wallets/rabby.webp",
    "description": "Connect using Rabby",
    "color": "#35a8df",
    "mark": "R",
    "aliases": [
      "Rabby Wallet"
    ],
    "chains": [],
    "adapterId": "rabby",
    "provider": "custom-adapter",
    "installUrl": "https://rabby.im/"
  },
  {
    "id": "leap",
    "name": "Leap Cosmos Wallet",
    "icon": "assets/wallet-modal/wallets/leap.webp",
    "description": "Connect using Leap Cosmos Wallet",
    "color": "#24b99a",
    "mark": "LC",
    "aliases": [
      "Leap"
    ],
    "chains": [
      "Cosmos"
    ],
    "adapterId": "leap",
    "provider": "custom-adapter",
    "installUrl": "https://leapcosmos.com/"
  },
  {
    "id": "upbond",
    "name": "UPBOND Wallet",
    "icon": "assets/wallet-modal/wallets/upbond.webp",
    "description": "Connect using UPBOND Wallet",
    "color": "#e879ae",
    "mark": "UW",
    "aliases": [],
    "chains": [],
    "adapterId": "upbond",
    "provider": "custom-adapter",
    "installUrl": "https://upbond.io/"
  },
  {
    "id": "vive",
    "name": "VIVE Wallet",
    "icon": "assets/wallet-modal/wallets/vive.webp",
    "description": "Connect using VIVE Wallet",
    "color": "#557eea",
    "mark": "VW",
    "aliases": [],
    "chains": [],
    "adapterId": "vive",
    "provider": "custom-adapter",
    "installUrl": "https://www.vive.io/"
  },
  {
    "id": "coca",
    "name": "COCA Wallet",
    "icon": "assets/wallet-modal/wallets/coca.webp",
    "description": "Connect using COCA Wallet",
    "color": "#c5aa54",
    "mark": "CW",
    "aliases": [],
    "chains": [],
    "adapterId": "coca",
    "provider": "custom-adapter",
    "installUrl": "https://coca.io/"
  },
  {
    "id": "bcertin",
    "name": "BCERTin Wallet",
    "icon": "assets/wallet-modal/wallets/bcertin.webp",
    "description": "Connect using BCERTin Wallet",
    "color": "#48b89c",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "bcertin",
    "provider": "custom-adapter",
    "installUrl": "https://bcertin.com/"
  },
  {
    "id": "monarch",
    "name": "Monarch Wallet",
    "icon": "assets/wallet-modal/wallets/monarch.webp",
    "description": "Connect using Monarch Wallet",
    "color": "#8063d9",
    "mark": "MW",
    "aliases": [],
    "chains": [],
    "adapterId": "monarch",
    "provider": "custom-adapter",
    "installUrl": "https://www.monarchwallet.com/"
  },
  {
    "id": "valora",
    "name": "Valora",
    "icon": "assets/wallet-modal/wallets/valora.webp",
    "description": "Connect using Valora",
    "color": "#de7a50",
    "mark": "V",
    "aliases": [],
    "chains": [
      "Celo"
    ],
    "adapterId": "valora",
    "provider": "custom-adapter",
    "installUrl": "https://valora.co/"
  },
  {
    "id": "coincircle",
    "name": "CoinCircle",
    "icon": "assets/wallet-modal/wallets/coincircle.webp",
    "description": "Connect using CoinCircle",
    "color": "#8b75ff",
    "mark": "C",
    "aliases": [],
    "chains": [],
    "adapterId": "coincircle",
    "provider": "custom-adapter",
    "installUrl": "https://coincircle.io/"
  },
  {
    "id": "mywallid",
    "name": "MyWalliD",
    "icon": "assets/wallet-modal/wallets/mywallid.webp",
    "description": "Connect using MyWalliD",
    "color": "#ee9b48",
    "mark": "M",
    "aliases": [],
    "chains": [],
    "adapterId": "mywallid",
    "provider": "custom-adapter",
    "installUrl": "https://mywallid.com/"
  },
  {
    "id": "gamestop",
    "name": "GameStop Wallet",
    "icon": "assets/wallet-modal/wallets/gamestop.webp",
    "description": "Connect using GameStop Wallet",
    "color": "#35a8df",
    "mark": "GW",
    "aliases": [],
    "chains": [],
    "adapterId": "gamestop",
    "provider": "custom-adapter",
    "installUrl": "https://gamestop.com/"
  },
  {
    "id": "paraswap",
    "name": "ParaSwap Wallet",
    "icon": "assets/wallet-modal/wallets/paraswap.webp",
    "description": "Connect using ParaSwap Wallet",
    "color": "#24b99a",
    "mark": "PW",
    "aliases": [],
    "chains": [],
    "adapterId": "paraswap",
    "provider": "custom-adapter",
    "installUrl": "https://paraswap.io/"
  },
  {
    "id": "uvtoken",
    "name": "UvToken",
    "icon": null,
    "description": "Connect using UvToken",
    "color": "#e879ae",
    "mark": "U",
    "aliases": [],
    "chains": [],
    "adapterId": "uvtoken",
    "provider": "custom-adapter",
    "installUrl": "https://uvtoken.com/"
  },
  {
    "id": "sahal",
    "name": "Sahal Wallet",
    "icon": "assets/wallet-modal/wallets/sahal.webp",
    "description": "Connect using Sahal Wallet",
    "color": "#557eea",
    "mark": "SW",
    "aliases": [],
    "chains": [],
    "adapterId": "sahal",
    "provider": "custom-adapter",
    "installUrl": "https://sahal.io/"
  },
  {
    "id": "apollox",
    "name": "ApolloX",
    "icon": "assets/wallet-modal/wallets/apollox.webp",
    "description": "Connect using ApolloX",
    "color": "#c5aa54",
    "mark": "A",
    "aliases": [],
    "chains": [],
    "adapterId": "apollox",
    "provider": "custom-adapter",
    "installUrl": "https://apollox.io/"
  },
  {
    "id": "nitrogen",
    "name": "Nitrogen Wallet",
    "icon": "assets/wallet-modal/wallets/nitrogen.webp",
    "description": "Connect using Nitrogen Wallet",
    "color": "#48b89c",
    "mark": "NW",
    "aliases": [],
    "chains": [],
    "adapterId": "nitrogen",
    "provider": "custom-adapter",
    "installUrl": "https://www.nitrogenwallet.com/"
  },
  {
    "id": "loopring",
    "name": "Loopring",
    "icon": "assets/wallet-modal/wallets/loopring.webp",
    "description": "Connect using Loopring",
    "color": "#8063d9",
    "mark": "L",
    "aliases": [],
    "chains": [],
    "adapterId": "loopring",
    "provider": "custom-adapter",
    "installUrl": "https://loopring.org/"
  },
  {
    "id": "bee",
    "name": "Bee Wallet",
    "icon": "assets/wallet-modal/wallets/bee.webp",
    "description": "Connect using Bee Wallet",
    "color": "#de7a50",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "bee",
    "provider": "custom-adapter",
    "installUrl": "https://beewallet.io/"
  },
  {
    "id": "dohmi",
    "name": "Dohmi Wallet",
    "icon": "assets/wallet-modal/wallets/dohmi.webp",
    "description": "Connect using Dohmi Wallet",
    "color": "#8b75ff",
    "mark": "DW",
    "aliases": [],
    "chains": [],
    "adapterId": "dohmi",
    "provider": "custom-adapter",
    "installUrl": "https://dohmiwallet.com/"
  },
  {
    "id": "magic",
    "name": "Magic Eden",
    "icon": "assets/wallet-modal/wallets/magic.webp",
    "description": "Connect using Magic Eden",
    "color": "#ee9b48",
    "mark": "ME",
    "aliases": [],
    "chains": [],
    "adapterId": "magic",
    "provider": "custom-adapter",
    "installUrl": "https://magiceden.io/"
  },
  {
    "id": "talk",
    "name": "Talk+",
    "icon": "assets/wallet-modal/wallets/talk.webp",
    "description": "Connect using Talk+",
    "color": "#35a8df",
    "mark": "T",
    "aliases": [],
    "chains": [],
    "adapterId": "talk",
    "provider": "custom-adapter",
    "installUrl": "https://talkplus.io/"
  },
  {
    "id": "at",
    "name": "AT.Wallet",
    "icon": "assets/wallet-modal/wallets/at.webp",
    "description": "Connect using AT.Wallet",
    "color": "#24b99a",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "at",
    "provider": "custom-adapter",
    "installUrl": "https://atwallet.com/"
  },
  {
    "id": "onto",
    "name": "ONTO",
    "icon": "assets/wallet-modal/wallets/onto.webp",
    "description": "Connect using ONTO",
    "color": "#e879ae",
    "mark": "O",
    "aliases": [],
    "chains": [],
    "adapterId": "onto",
    "provider": "custom-adapter",
    "installUrl": "https://onto.im/"
  },
  {
    "id": "secux",
    "name": "SecuX",
    "icon": "assets/wallet-modal/wallets/secux.webp",
    "description": "Connect using SecuX",
    "color": "#557eea",
    "mark": "S",
    "aliases": [],
    "chains": [],
    "adapterId": "secux",
    "provider": "custom-adapter",
    "installUrl": "https://secux.io/"
  },
  {
    "id": "blocto",
    "name": "Blocto",
    "icon": "assets/wallet-modal/wallets/blocto.webp",
    "description": "Connect using Blocto",
    "color": "#c5aa54",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "blocto",
    "provider": "custom-adapter",
    "installUrl": "https://blocto.app/"
  },
  {
    "id": "phantom",
    "name": "Phantom",
    "icon": "assets/wallet-modal/wallets/phantom.webp",
    "description": "Connect using Phantom",
    "color": "#48b89c",
    "mark": "P",
    "aliases": [
      "Phantom Wallet"
    ],
    "chains": [
      "Solana"
    ],
    "adapterId": "phantom",
    "provider": "custom-adapter",
    "installUrl": "https://phantom.app/"
  },
  {
    "id": "paper",
    "name": "Paper",
    "icon": "assets/wallet-modal/wallets/paper.webp",
    "description": "Connect using Paper",
    "color": "#8063d9",
    "mark": "P",
    "aliases": [],
    "chains": [],
    "adapterId": "paper",
    "provider": "custom-adapter",
    "installUrl": "https://paper.xyz/"
  },
  {
    "id": "dcent",
    "name": "D'CENT Wallet",
    "icon": "assets/wallet-modal/wallets/dcent.webp",
    "description": "Connect using D'CENT Wallet",
    "color": "#de7a50",
    "mark": "DC",
    "aliases": [
      "Dcent"
    ],
    "chains": [],
    "adapterId": "dcent",
    "provider": "custom-adapter",
    "installUrl": "https://dcentwallet.com/"
  },
  {
    "id": "frame",
    "name": "Frame",
    "icon": "assets/wallet-modal/wallets/frame.webp",
    "description": "Connect using Frame",
    "color": "#8b75ff",
    "mark": "F",
    "aliases": [],
    "chains": [],
    "adapterId": "frame",
    "provider": "custom-adapter",
    "installUrl": "https://frame.io/"
  },
  {
    "id": "torus",
    "name": "Torus",
    "icon": "assets/wallet-modal/wallets/torus.webp",
    "description": "Connect using Torus",
    "color": "#ee9b48",
    "mark": "T",
    "aliases": [
      "Web3Auth"
    ],
    "chains": [],
    "adapterId": "torus",
    "provider": "custom-adapter",
    "installUrl": "https://tor.us/"
  },
  {
    "id": "core",
    "name": "Core",
    "icon": "assets/wallet-modal/wallets/core.webp",
    "description": "Connect using Core",
    "color": "#35a8df",
    "mark": "C",
    "aliases": [],
    "chains": [
      "Avalanche"
    ],
    "adapterId": "core",
    "provider": "custom-adapter",
    "installUrl": "https://core.app/"
  },
  {
    "id": "pier",
    "name": "pier",
    "icon": "assets/wallet-modal/wallets/pier.webp",
    "description": "Connect using pier",
    "color": "#24b99a",
    "mark": "P",
    "aliases": [],
    "chains": [],
    "adapterId": "pier",
    "provider": "custom-adapter",
    "installUrl": "https://pier.app/"
  },
  {
    "id": "brave",
    "name": "Brave Wallet",
    "icon": "assets/wallet-modal/wallets/brave.webp",
    "description": "Connect using Brave Wallet",
    "color": "#e879ae",
    "mark": "BW",
    "aliases": [],
    "chains": [],
    "adapterId": "brave",
    "provider": "custom-adapter",
    "installUrl": "https://brave.com/"
  },
  {
    "id": "crossmint",
    "name": "Crossmint",
    "icon": "assets/wallet-modal/wallets/crossmint.webp",
    "description": "Connect using Crossmint",
    "color": "#557eea",
    "mark": "C",
    "aliases": [],
    "chains": [],
    "adapterId": "crossmint",
    "provider": "custom-adapter",
    "installUrl": "https://crossmint.io/"
  },
  {
    "id": "keplr",
    "name": "Keplr",
    "icon": "assets/wallet-modal/wallets/keplr.webp",
    "description": "Connect using Keplr",
    "color": "#c5aa54",
    "mark": "K",
    "aliases": [],
    "chains": [
      "Cosmos"
    ],
    "adapterId": "keplr",
    "provider": "custom-adapter",
    "installUrl": "https://keplr.app/"
  },
  {
    "id": "linen",
    "name": "Linen",
    "icon": "assets/wallet-modal/wallets/linen.webp",
    "description": "Connect using Linen",
    "color": "#48b89c",
    "mark": "L",
    "aliases": [],
    "chains": [],
    "adapterId": "linen",
    "provider": "custom-adapter",
    "installUrl": "https://linen.network/"
  },
  {
    "id": "nabox",
    "name": "Nabox",
    "icon": "assets/wallet-modal/wallets/nabox.webp",
    "description": "Connect using Nabox",
    "color": "#8063d9",
    "mark": "N",
    "aliases": [],
    "chains": [],
    "adapterId": "nabox",
    "provider": "custom-adapter",
    "installUrl": "https://nabox.io/"
  },
  {
    "id": "bcvault",
    "name": "BC Vault",
    "icon": "assets/wallet-modal/wallets/bcvault.webp",
    "description": "Connect using BC Vault",
    "color": "#de7a50",
    "mark": "BV",
    "aliases": [],
    "chains": [],
    "adapterId": "bcvault",
    "provider": "custom-adapter",
    "installUrl": "https://bcvault.io/"
  },
  {
    "id": "neon",
    "name": "Neon Wallet",
    "icon": "assets/wallet-modal/wallets/neon.webp",
    "description": "Connect using Neon Wallet",
    "color": "#8b75ff",
    "mark": "NW",
    "aliases": [],
    "chains": [
      "NEO"
    ],
    "adapterId": "neon",
    "provider": "custom-adapter",
    "installUrl": "https://neonwallet.io/"
  },
  {
    "id": "absolute",
    "name": "Absolute Wallet",
    "icon": "assets/wallet-modal/wallets/absolute.webp",
    "description": "Connect using Absolute Wallet",
    "color": "#ee9b48",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "absolute",
    "provider": "custom-adapter",
    "installUrl": "https://absolute.com/"
  },
  {
    "id": "sequence",
    "name": "Sequence Wallet",
    "icon": "assets/wallet-modal/wallets/sequence.webp",
    "description": "Connect using Sequence Wallet",
    "color": "#35a8df",
    "mark": "SW",
    "aliases": [],
    "chains": [],
    "adapterId": "sequence",
    "provider": "custom-adapter",
    "installUrl": "https://sequence.app/"
  },
  {
    "id": "ownbit",
    "name": "Ownbit",
    "icon": "assets/wallet-modal/wallets/ownbit.webp",
    "description": "Connect using Ownbit",
    "color": "#24b99a",
    "mark": "O",
    "aliases": [],
    "chains": [],
    "adapterId": "ownbit",
    "provider": "custom-adapter",
    "installUrl": "https://ownbit.io/"
  },
  {
    "id": "rice",
    "name": "RiceWallet",
    "icon": "assets/wallet-modal/wallets/rice.webp",
    "description": "Connect using RiceWallet",
    "color": "#e879ae",
    "mark": "R",
    "aliases": [],
    "chains": [],
    "adapterId": "rice",
    "provider": "custom-adapter",
    "installUrl": "https://ricewallet.com/"
  },
  {
    "id": "bytebank",
    "name": "ByteBank",
    "icon": "assets/wallet-modal/wallets/bytebank.webp",
    "description": "Connect using ByteBank",
    "color": "#557eea",
    "mark": "B",
    "aliases": [],
    "chains": [],
    "adapterId": "bytebank",
    "provider": "custom-adapter",
    "installUrl": "https://bytebank.io/"
  },
  {
    "id": "mdao",
    "name": "MDAO Wallet",
    "icon": "assets/wallet-modal/wallets/mdao.webp",
    "description": "Connect using MDAO Wallet",
    "color": "#c5aa54",
    "mark": "MW",
    "aliases": [],
    "chains": [],
    "adapterId": "mdao",
    "provider": "custom-adapter",
    "installUrl": "https://mdao.io/"
  },
  {
    "id": "payperless",
    "name": "Payperless",
    "icon": "assets/wallet-modal/wallets/payperless.webp",
    "description": "Connect using Payperless",
    "color": "#48b89c",
    "mark": "P",
    "aliases": [],
    "chains": [],
    "adapterId": "payperless",
    "provider": "custom-adapter",
    "installUrl": "https://payperless.com/"
  },
  {
    "id": "lif3",
    "name": "Lif3 Wallet",
    "icon": "assets/wallet-modal/wallets/lif3.webp",
    "description": "Connect using Lif3 Wallet",
    "color": "#8063d9",
    "mark": "LW",
    "aliases": [],
    "chains": [],
    "adapterId": "lif3",
    "provider": "custom-adapter",
    "installUrl": "https://lif3.io/"
  },
  {
    "id": "prema",
    "name": "PREMA Wallet",
    "icon": "assets/wallet-modal/wallets/prema.webp",
    "description": "Connect using PREMA Wallet",
    "color": "#de7a50",
    "mark": "PW",
    "aliases": [],
    "chains": [],
    "adapterId": "prema",
    "provider": "custom-adapter",
    "installUrl": "https://prema.io/"
  },
  {
    "id": "onekey",
    "name": "OneKey",
    "icon": "assets/wallet-modal/wallets/onekey.webp",
    "description": "Connect using OneKey",
    "color": "#8b75ff",
    "mark": "O",
    "aliases": [],
    "chains": [],
    "adapterId": "onekey",
    "provider": "custom-adapter",
    "installUrl": "https://onekey.so/"
  },
  {
    "id": "xdefi",
    "name": "XDEFI Wallet",
    "icon": "assets/wallet-modal/wallets/xdefi.webp",
    "description": "Connect using XDEFI Wallet",
    "color": "#ee9b48",
    "mark": "XW",
    "aliases": [
      "XDEFI",
      "Ctrl Wallet"
    ],
    "chains": [],
    "adapterId": "xdefi",
    "provider": "custom-adapter",
    "installUrl": "https://xdefi.io/"
  },
  {
    "id": "keepkey",
    "name": "KeepKey Wallet",
    "icon": "assets/wallet-modal/wallets/keepkey.webp",
    "description": "Connect using KeepKey Wallet",
    "color": "#35a8df",
    "mark": "KW",
    "aliases": [],
    "chains": [],
    "adapterId": "keepkey",
    "provider": "custom-adapter",
    "installUrl": "https://keepkey.com/"
  },
  {
    "id": "nova",
    "name": "Nova Wallet",
    "icon": "assets/wallet-modal/wallets/nova.webp",
    "description": "Connect using Nova Wallet",
    "color": "#24b99a",
    "mark": "NW",
    "aliases": [],
    "chains": [],
    "adapterId": "nova",
    "provider": "custom-adapter",
    "installUrl": "https://novawallet.io/"
  },
  {
    "id": "zelcore",
    "name": "Zelcore",
    "icon": "assets/wallet-modal/wallets/zelcore.webp",
    "description": "Connect using Zelcore",
    "color": "#e879ae",
    "mark": "Z",
    "aliases": [],
    "chains": [],
    "adapterId": "zelcore",
    "provider": "custom-adapter",
    "installUrl": "https://zelcore.io/"
  },
  {
    "id": "kraken",
    "name": "Kraken Wallet",
    "icon": "assets/wallet-modal/wallets/kraken.webp",
    "description": "Connect using Kraken Wallet",
    "color": "#557eea",
    "mark": "KW",
    "aliases": [],
    "chains": [],
    "adapterId": "kraken",
    "provider": "custom-adapter",
    "installUrl": "https://kraken.com/"
  },
  {
    "id": "moonpay",
    "name": "MoonPay Wallet",
    "icon": "assets/wallet-modal/wallets/moonpay.webp",
    "description": "Connect using MoonPay Wallet",
    "color": "#c5aa54",
    "mark": "MW",
    "aliases": [],
    "chains": [],
    "adapterId": "moonpay",
    "provider": "custom-adapter",
    "installUrl": "https://moonpay.com/"
  },
  {
    "id": "keychain",
    "name": "Keychain Wallet",
    "icon": "assets/wallet-modal/wallets/keychain.webp",
    "description": "Connect using Keychain Wallet",
    "color": "#48b89c",
    "mark": "KW",
    "aliases": [],
    "chains": [],
    "adapterId": "keychain",
    "provider": "custom-adapter",
    "installUrl": "https://keychain.io/"
  },
  {
    "id": "dreamos",
    "name": "DreamOS",
    "icon": "assets/wallet-modal/wallets/dreamos.webp",
    "description": "Connect using DreamOS",
    "color": "#8063d9",
    "mark": "D",
    "aliases": [],
    "chains": [],
    "adapterId": "dreamos",
    "provider": "custom-adapter",
    "installUrl": "https://dreamos.io/"
  },
  {
    "id": "fintoken",
    "name": "FINTOKEN",
    "icon": "assets/wallet-modal/wallets/fintoken.webp",
    "description": "Connect using FINTOKEN",
    "color": "#de7a50",
    "mark": "F",
    "aliases": [],
    "chains": [],
    "adapterId": "fintoken",
    "provider": "custom-adapter",
    "installUrl": "https://fintoken.io/"
  },
  {
    "id": "peakdefi",
    "name": "PEAKDEFI",
    "icon": "assets/wallet-modal/wallets/peakdefi.webp",
    "description": "Connect using PEAKDEFI",
    "color": "#8b75ff",
    "mark": "P",
    "aliases": [],
    "chains": [],
    "adapterId": "peakdefi",
    "provider": "custom-adapter",
    "installUrl": "https://peakdefi.com/"
  },
  {
    "id": "coin98",
    "name": "Coin98 Super Wallet",
    "icon": "assets/wallet-modal/wallets/coin98.webp",
    "description": "Connect using Coin98 Super Wallet",
    "color": "#ee9b48",
    "mark": "CS",
    "aliases": [
      "Coin98"
    ],
    "chains": [],
    "adapterId": "coin98",
    "provider": "custom-adapter",
    "installUrl": "https://coin98.com/"
  },
  {
    "id": "qubic",
    "name": "Qubic Wallet",
    "icon": "assets/wallet-modal/wallets/qubic.webp",
    "description": "Connect using Qubic Wallet",
    "color": "#35a8df",
    "mark": "QW",
    "aliases": [],
    "chains": [],
    "adapterId": "qubic",
    "provider": "custom-adapter",
    "installUrl": "https://qubic.io/"
  },
  {
    "id": "krypto",
    "name": "KryptoGO Wallet",
    "icon": "assets/wallet-modal/wallets/krypto.webp",
    "description": "Connect using KryptoGO Wallet",
    "color": "#24b99a",
    "mark": "KW",
    "aliases": [],
    "chains": [],
    "adapterId": "krypto",
    "provider": "custom-adapter",
    "installUrl": "https://kryptogowallet.com/"
  },
  {
    "id": "abra",
    "name": "Abra Wallet",
    "icon": "assets/wallet-modal/wallets/abra.webp",
    "description": "Connect using Abra Wallet",
    "color": "#e879ae",
    "mark": "AW",
    "aliases": [],
    "chains": [],
    "adapterId": "abra",
    "provider": "custom-adapter",
    "installUrl": "https://abra.io/"
  },
  {
    "id": "halo",
    "name": "Halo Wallet",
    "icon": "assets/wallet-modal/wallets/halo.webp",
    "description": "Connect using Halo Wallet",
    "color": "#557eea",
    "mark": "HW",
    "aliases": [],
    "chains": [],
    "adapterId": "halo",
    "provider": "custom-adapter",
    "installUrl": "https://halowallet.io/"
  },
  {
    "id": "binanceus",
    "name": "Binance.US",
    "icon": "assets/wallet-modal/wallets/binanceus.webp",
    "description": "Connect using Binance.US",
    "color": "#c5aa54",
    "mark": "BU",
    "aliases": [],
    "chains": [],
    "adapterId": "binanceus",
    "provider": "custom-adapter",
    "installUrl": "https://binance.us/"
  },
  {
    "id": "gem",
    "name": "Gem Wallet",
    "icon": "assets/wallet-modal/wallets/gem.webp",
    "description": "Connect using Gem Wallet",
    "color": "#48b89c",
    "mark": "GW",
    "aliases": [],
    "chains": [],
    "adapterId": "gem",
    "provider": "custom-adapter",
    "installUrl": "https://gemwallet.io/"
  }
]
